// React
import React from 'react'
import { useSelector } from 'react-redux'
import { compose } from 'redux'

// Components
import { ModalCartPicker } from 'store/modules/cart/CartPicker/Modal'

// Hooks
import { useDatePicker } from 'store/hooks/useDatePicker'
import { useOrm } from 'shared/utils/useOrm'

// Shared
import withStore from 'shop-components/utils/withStore'
import withTheme from 'shop-components/utils/withTheme'

const EmbeddableCartPicker = () => {
  const { isOpen, close } = useDatePicker()

  const cartId = useSelector((state) => state.client.cartId)
  const cart = useOrm('carts', (carts) => carts.getById(cartId || window.booqableOptions.cart?.id))

  if (!cart) return null

  return <ModalCartPicker open={isOpen} onClose={close} />
}

export default compose(withStore, withTheme)(EmbeddableCartPicker)
